import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, Renderer2, SimpleChanges, ViewChild } from '@angular/core';
import { AdvancedSearchControl } from '../../../../../../interfaces/advancedSearch.interface';

@Component({
    selector: 'app-advanced-search-more-options-list',
    templateUrl: './advanced-search-more-options-list.component.html',
    styleUrls: ['./advanced-search-more-options-list.component.scss']
})
export class AdvancedSearchMoreOptionsListComponent implements OnInit, AfterViewInit, OnChanges {

    @Input() items: AdvancedSearchControl[] = [];
    @Input() subMenuLevel = 0;
    @Input() maxWidth = 200;
    @Input() maxHeight = 180;

    @Output('additionalFilterAdd') additionalFilterAddEvEm = new EventEmitter();
    @Output('additionalFilterEnterSub') additionalFilterAEnterSubEvEm = new EventEmitter();
    @Output('backClick') backClickEvEm = new EventEmitter();

    @ViewChild('listWrapper', { static: false }) listWrapper: ElementRef<Element>;

    itemsToShow: AdvancedSearchControl[] = [];

    constructor(
        private renderer: Renderer2
    ) { }


    ngOnInit(): void { }

    ngAfterViewInit(): void {
        this._calculateDimensions();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes && changes.items && changes.items.currentValue) {
            this.itemsToShow = this.items;
        }
    }

    onAdditionalFilterAdd(addFilterCtrl: AdvancedSearchControl) {
        this.additionalFilterAddEvEm.emit(addFilterCtrl);
        this._calculateDimensions();
    }

    onSubMenuBackClick() {
        // this.backClickEvEm.emit();
        // this._calculateDimensions();
        this.subMenuLevel = 0;
        this.updateItemsToShowList(this.items);
    }

    openSubMenu(addFilterCtrl: AdvancedSearchControl) {
        // this.additionalFilterAEnterSubEvEm.emit(addFilterCtrl);
        // this._calculateDimensions();
        this.subMenuLevel = 1;
        this.updateItemsToShowList(addFilterCtrl.subMenu);
    }

    private updateItemsToShowList(controls: AdvancedSearchControl[]) {
        this.itemsToShow = controls;
        this._calculateDimensions();
    }

    private _calculateDimensions() {
        setTimeout(() => {
            if (this.listWrapper) {
                const scrollerWrapper = this.listWrapper.nativeElement.getElementsByClassName('ng-scroll-content')[0];
                const clientWidth = scrollerWrapper.clientWidth;
                const clientHeight = scrollerWrapper.clientHeight + 4;

                const contentWidth = clientWidth < this.maxWidth ?
                    clientWidth : this.maxWidth;
                const contentHeight = clientHeight < this.maxHeight ?
                    clientHeight : this.maxHeight;
                this.renderer.setStyle(this.listWrapper.nativeElement, 'width', contentWidth + 'px');
                this.renderer.setStyle(this.listWrapper.nativeElement, 'height', contentHeight + 'px');
            }
        });

    }
}
